import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vShow as _vShow, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "min-h-screen",
  "data-theme": "teal"
}
const _hoisted_2 = { class: "max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_3 = { class: "flex items-center justify-between mb-8" }
const _hoisted_4 = { class: "text-2xl font-bold text-gray-900" }
const _hoisted_5 = { class: "mb-6 bg-white rounded-xl shadow-sm border border-gray-200 p-4" }
const _hoisted_6 = { class: "flex flex-wrap items-center gap-4" }
const _hoisted_7 = { class: "flex items-center gap-2" }
const _hoisted_8 = { class: "text-xs text-gray-500" }
const _hoisted_9 = { value: "" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "flex items-center gap-2" }
const _hoisted_12 = { class: "text-xs text-gray-500" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "text-xs text-gray-400 ml-auto" }
const _hoisted_15 = { class: "mb-8 bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden map-container" }
const _hoisted_16 = {
  ref: "mapContainer",
  style: {"height":"320px","width":"100%"}
}
const _hoisted_17 = {
  key: 1,
  class: "text-center py-12 text-gray-500"
}
const _hoisted_18 = { class: "grid gap-4" }
const _hoisted_19 = { class: "flex items-start justify-between" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "flex-1" }
const _hoisted_22 = { class: "text-lg font-semibold text-gray-900 mb-1" }
const _hoisted_23 = { class: "flex flex-wrap gap-2 mb-2" }
const _hoisted_24 = {
  key: 0,
  class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
}
const _hoisted_25 = {
  key: 1,
  class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-700"
}
const _hoisted_26 = {
  key: 2,
  class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-600 text-white"
}
const _hoisted_27 = {
  key: 3,
  class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800"
}
const _hoisted_28 = {
  key: 0,
  class: "text-xs text-gray-400 mb-1"
}
const _hoisted_29 = {
  key: 1,
  class: "text-sm text-gray-600 mb-2"
}
const _hoisted_30 = { class: "flex items-center gap-3" }
const _hoisted_31 = ["href"]
const _hoisted_32 = ["href"]
const _hoisted_33 = ["href"]
const _hoisted_34 = ["href"]
const _hoisted_35 = {
  key: 1,
  class: "flex flex-col gap-2 ml-4"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "bg-white rounded-xl shadow-xl w-full max-w-md mx-4 p-6 max-h-[90vh] overflow-y-auto" }
const _hoisted_40 = { class: "text-lg font-bold text-gray-900 mb-6" }
const _hoisted_41 = {
  key: 0,
  class: "mb-4 bg-red-50 border border-red-200 rounded-lg px-4 py-3"
}
const _hoisted_42 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_43 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_44 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_45 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_46 = { class: "flex items-center gap-2" }
const _hoisted_47 = {
  for: "coach-online",
  class: "text-sm font-medium text-gray-700"
}
const _hoisted_48 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_49 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_50 = { class: "flex items-center justify-between mb-2" }
const _hoisted_51 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_52 = { class: "flex items-center justify-between mb-2" }
const _hoisted_53 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_56 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_57 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_58 = { class: "flex justify-end gap-3 pt-4" }
const _hoisted_59 = ["disabled"]
const _hoisted_60 = { class: "bg-white rounded-xl shadow-xl w-full max-w-sm mx-4 p-6" }
const _hoisted_61 = { class: "text-lg font-bold text-gray-900 mb-2" }
const _hoisted_62 = { class: "text-sm text-gray-600 mb-6" }
const _hoisted_63 = { class: "flex justify-end gap-3" }
const _hoisted_64 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavBar"], {
      "signed-in": $props.signedIn,
      "user-name": $props.userName,
      "active-page": "coaches"
    }, null, 8 /* PROPS */, ["signed-in", "user-name"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString($setup.t('coaches.title')), 1 /* TEXT */),
        ($props.signedIn)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: $setup.openCreateModal,
              class: "bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-800 transition"
            }, _toDisplayString($setup.t('coaches.create')), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createCommentVNode(" Filters "),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString($setup.t('coaches.filter_city')) + ":", 1 /* TEXT */),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.filterCity) = $event)),
              class: "text-xs border border-gray-300 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500"
            }, [
              _createElementVNode("option", _hoisted_9, _toDisplayString($setup.t('coaches.filter_all')), 1 /* TEXT */),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cities, (city) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: city,
                  value: city
                }, _toDisplayString(city), 9 /* TEXT, PROPS */, _hoisted_10))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, $setup.filterCity]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", _hoisted_12, _toDisplayString($setup.t('coaches.filter_search')) + ":", 1 /* TEXT */),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.filterSearch) = $event)),
              type: "text",
              placeholder: $setup.t('coaches.filter_search_placeholder'),
              class: "text-xs border border-gray-300 rounded-lg px-2 py-1.5 w-48 focus:outline-none focus:ring-2 focus:ring-blue-500"
            }, null, 8 /* PROPS */, _hoisted_13), [
              [_vModelText, $setup.filterSearch]
            ])
          ]),
          _createElementVNode("span", _hoisted_14, _toDisplayString($setup.filteredCoaches.length) + " / " + _toDisplayString($setup.items.length), 1 /* TEXT */)
        ])
      ]),
      _createCommentVNode(" Map "),
      _withDirectives(_createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, null, 512 /* NEED_PATCH */)
      ], 512 /* NEED_PATCH */), [
        [_vShow, $setup.allLocations.length > 0]
      ]),
      _createCommentVNode(" Flash "),
      ($setup.flash)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['mb-4 px-4 py-3 rounded-lg text-sm', $setup.flash.type === 'success' ? 'bg-blue-100 text-blue-800' : 'bg-red-100 text-red-800'])
          }, _toDisplayString($setup.flash.message), 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" List "),
      ($setup.filteredCoaches.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString($setup.t('coaches.no_coaches')), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_18, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredCoaches, (coach) => {
          return (_openBlock(), _createElementBlock("div", {
            key: coach.id,
            class: "bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition"
          }, [
            _createElementVNode("div", _hoisted_19, [
              (coach.logo_url)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: coach.logo_url,
                    class: "w-14 h-14 rounded-lg object-cover border border-gray-200 shrink-0"
                  }, null, 8 /* PROPS */, _hoisted_20))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("h3", _hoisted_22, _toDisplayString(coach.name), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_23, [
                  (coach.city)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(coach.city), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (coach.club)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(coach.club), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (coach.online)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString($setup.t('coaches.online')), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (coach.pending)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString($setup.t('coaches.pending')), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                (coach.locations && coach.locations.length > 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(coach.locations.map(l => l.name || $setup.t('coaches.location')).join(', ')), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                ($setup.coachDescription(coach))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString($setup.coachDescription(coach)), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_30, [
                  (coach.phone)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: 'tel:' + coach.phone,
                        class: "inline-flex items-center gap-1 text-sm text-blue-700 hover:underline"
                      }, [
                        _cache[12] || (_cache[12] = _createElementVNode("svg", {
                          class: "w-3.5 h-3.5",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                          })
                        ], -1 /* CACHED */)),
                        _createTextVNode(" " + _toDisplayString(coach.phone), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_31))
                    : _createCommentVNode("v-if", true),
                  (coach.facebook_link)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: coach.facebook_link,
                        target: "_blank",
                        class: "hover:opacity-80 transition"
                      }, [...(_cache[13] || (_cache[13] = [
                        _createElementVNode("svg", {
                          class: "w-5 h-5",
                          viewBox: "0 0 24 24",
                          fill: "#1877F2"
                        }, [
                          _createElementVNode("path", { d: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" })
                        ], -1 /* CACHED */)
                      ]))], 8 /* PROPS */, _hoisted_32))
                    : _createCommentVNode("v-if", true),
                  (coach.instagram_link)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        href: coach.instagram_link,
                        target: "_blank",
                        class: "hover:opacity-80 transition"
                      }, [...(_cache[14] || (_cache[14] = [
                        _createStaticVNode("<svg class=\"w-5 h-5\" viewBox=\"0 0 24 24\"><defs><linearGradient id=\"ig\" x1=\"0%\" y1=\"100%\" x2=\"100%\" y2=\"0%\"><stop offset=\"0%\" stop-color=\"#feda75\"></stop><stop offset=\"25%\" stop-color=\"#fa7e1e\"></stop><stop offset=\"50%\" stop-color=\"#d62976\"></stop><stop offset=\"75%\" stop-color=\"#962fbf\"></stop><stop offset=\"100%\" stop-color=\"#4f5bd5\"></stop></linearGradient></defs><path fill=\"url(#ig)\" d=\"M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12s.014 3.668.072 4.948c.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24s3.668-.014 4.948-.072c4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948s-.014-3.667-.072-4.947c-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z\"></path></svg>", 1)
                      ]))], 8 /* PROPS */, _hoisted_33))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("a", {
                    href: `/coaches/${coach.id}`,
                    class: "text-sm text-blue-700 font-medium hover:underline"
                  }, _toDisplayString($setup.t('coaches.details')) + " →", 9 /* TEXT, PROPS */, _hoisted_34)
                ])
              ]),
              ($props.userAdmin || coach.user_id === $props.userId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    ($props.userAdmin && coach.pending)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: $event => ($setup.approveItem(coach)),
                          class: "px-3 py-1.5 text-xs font-medium text-green-700 bg-green-50 rounded-lg hover:bg-green-100 transition"
                        }, _toDisplayString($setup.t('coaches.approve')), 9 /* TEXT, PROPS */, _hoisted_36))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("button", {
                      onClick: $event => ($setup.openEditModal(coach)),
                      class: "px-3 py-1.5 text-xs font-medium text-blue-700 bg-blue-50 rounded-lg hover:bg-blue-100 transition"
                    }, _toDisplayString($setup.t('coaches.edit')), 9 /* TEXT, PROPS */, _hoisted_37),
                    _createElementVNode("button", {
                      onClick: $event => ($setup.confirmDelete(coach)),
                      class: "px-3 py-1.5 text-xs font-medium text-red-700 bg-red-50 rounded-lg hover:bg-red-100 transition"
                    }, _toDisplayString($setup.t('coaches.delete')), 9 /* TEXT, PROPS */, _hoisted_38)
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _createCommentVNode(" Create/Edit Modal "),
    ($setup.showModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50",
          onClick: _withModifiers($setup.closeModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("h2", _hoisted_40, _toDisplayString($setup.editing ? $setup.t('coaches.edit_coach') : $setup.t('coaches.new_coach')), 1 /* TEXT */),
            ($setup.formErrors.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.formErrors, (error) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: error,
                      class: "text-sm text-red-700"
                    }, _toDisplayString(error), 1 /* TEXT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("form", {
              onSubmit: _withModifiers($setup.submitForm, ["prevent"]),
              class: "space-y-4"
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_42, _toDisplayString($setup.t('coaches.name')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.form.name) = $event)),
                  type: "text",
                  required: "",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.form.name]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_43, _toDisplayString($setup.t('coaches.club')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.form.club) = $event)),
                  type: "text",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.form.club]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_44, _toDisplayString($setup.t('coaches.city')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.form.city) = $event)),
                  type: "text",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.form.city]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_45, _toDisplayString($setup.t('coaches.phone')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.form.phone) = $event)),
                  type: "tel",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.form.phone]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Facebook", -1 /* CACHED */)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.form.facebook_link) = $event)),
                  type: "url",
                  placeholder: "https://facebook.com/...",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.form.facebook_link]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Instagram", -1 /* CACHED */)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($setup.form.instagram_link) = $event)),
                  type: "url",
                  placeholder: "https://instagram.com/...",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.form.instagram_link]
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.form.online) = $event)),
                  type: "checkbox",
                  id: "coach-online",
                  class: "w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.form.online]
                ]),
                _createElementVNode("label", _hoisted_47, _toDisplayString($setup.t('coaches.online')), 1 /* TEXT */)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_48, _toDisplayString($setup.t('coaches.description')) + " (RO)", 1 /* TEXT */),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($setup.form.description_ro) = $event)),
                  rows: "2",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.form.description_ro]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_49, _toDisplayString($setup.t('coaches.description')) + " (RU)", 1 /* TEXT */),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($setup.form.description_ru) = $event)),
                  rows: "2",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.form.description_ru]
                ])
              ]),
              _createVNode($setup["ImageUpload"], {
                modelValue: $setup.form.logo_url,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($setup.form.logo_url) = $event)),
                label: $setup.t('coaches.logo'),
                "upload-text": $setup.t('coaches.upload_logo'),
                "change-text": $setup.t('coaches.change_logo'),
                "remove-text": $setup.t('coaches.remove_logo'),
                "csrf-token": $props.csrfToken,
                "upload-type": "coaches"
              }, null, 8 /* PROPS */, ["modelValue", "label", "upload-text", "change-text", "remove-text", "csrf-token"]),
              _createCommentVNode(" Locations "),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("label", _hoisted_51, _toDisplayString($setup.t('coaches.locations')), 1 /* TEXT */),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: $setup.addLocation,
                    class: "text-xs text-blue-700 hover:text-blue-900 font-medium"
                  }, "+ " + _toDisplayString($setup.t('coaches.add_location')), 1 /* TEXT */)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.form.locations, (loc, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: idx,
                    class: "mb-3 p-3 bg-gray-50 rounded-lg border border-gray-200"
                  }, [
                    _createElementVNode("div", _hoisted_52, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": $event => ((loc.name) = $event),
                        type: "text",
                        placeholder: $setup.t('coaches.location_name'),
                        class: "flex-1 px-2 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                      }, null, 8 /* PROPS */, _hoisted_53), [
                        [_vModelText, loc.name]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: $event => ($setup.removeLocation(idx)),
                        class: "ml-2 text-red-400 hover:text-red-600 text-sm"
                      }, "×", 8 /* PROPS */, _hoisted_54)
                    ]),
                    _createElementVNode("div", {
                      ref_for: true,
                      ref: el => { if (el) $setup.formMapRefs[idx] = el },
                      style: {"height":"150px","width":"100%"},
                      class: "rounded border border-gray-300 mb-2"
                    }, null, 512 /* NEED_PATCH */),
                    _createElementVNode("div", _hoisted_55, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": $event => ((loc.latitude) = $event),
                        type: "number",
                        step: "0.0000001",
                        readonly: "",
                        placeholder: $setup.t('coaches.latitude'),
                        class: "px-2 py-1 border border-gray-300 rounded bg-gray-50 text-xs"
                      }, null, 8 /* PROPS */, _hoisted_56), [
                        [_vModelText, loc.latitude]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": $event => ((loc.longitude) = $event),
                        type: "number",
                        step: "0.0000001",
                        readonly: "",
                        placeholder: $setup.t('coaches.longitude'),
                        class: "px-2 py-1 border border-gray-300 rounded bg-gray-50 text-xs"
                      }, null, 8 /* PROPS */, _hoisted_57), [
                        [_vModelText, loc.longitude]
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: $setup.closeModal,
                  class: "px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
                }, _toDisplayString($setup.t('coaches.cancel')), 1 /* TEXT */),
                _createElementVNode("button", {
                  type: "submit",
                  disabled: $setup.submitting,
                  class: "px-4 py-2 text-sm font-medium text-white bg-blue-700 rounded-lg hover:bg-blue-800 transition disabled:opacity-50"
                }, _toDisplayString($setup.submitting ? '...' : ($setup.editing ? $setup.t('coaches.save') : $setup.t('coaches.create'))), 9 /* TEXT, PROPS */, _hoisted_59)
              ])
            ], 32 /* NEED_HYDRATION */)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Delete Modal "),
    ($setup.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50",
          onClick: _withModifiers($setup.closeDeleteModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("h2", _hoisted_61, _toDisplayString($setup.t('coaches.confirm_delete')), 1 /* TEXT */),
            _createElementVNode("p", _hoisted_62, _toDisplayString($setup.t('coaches.confirm_delete_message')), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("button", {
                onClick: $setup.closeDeleteModal,
                class: "px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
              }, _toDisplayString($setup.t('coaches.cancel')), 1 /* TEXT */),
              _createElementVNode("button", {
                onClick: $setup.deleteCoach,
                disabled: $setup.submitting,
                class: "px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition disabled:opacity-50"
              }, _toDisplayString($setup.submitting ? '...' : $setup.t('coaches.delete')), 9 /* TEXT, PROPS */, _hoisted_64)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}